import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useRsvp } from '../context/RsvpContext';

const ProtectedRoute: React.FC = () => {
    const { rsvp, isLoading } = useRsvp();

    // While the context is loading the session, render nothing.
    // This prevents a premature redirect.
    if (isLoading) {
        return null; // Or a loading spinner component
    }

    // If loading is finished and there's still no user, then redirect.
    if (!isLoading && !rsvp) {
        return <Navigate to="/code-gate" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;